<template>
  <div>
    <kst-output print-mode field="AdjNumber" :data="details" :catalog="Catalog"/>
    <kst-output print-mode field="Date" :data="details" :catalog="Catalog"/>
    <kst-output print-mode field="WarehouseID" :data="details" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../HpadCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>